import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, ChevronRight, Star } from "lucide-react";
import { getHoroscopeSign } from "@/lib/api";
import { readMySign, ZODIAC_SIGNS } from "@/lib/readoo";
import { useAuth } from "@/context/AuthContext";
import { StarRating } from "@/components/primitives";

const VIOLET = "#8b5cf6";

export function MySignCard() {
  const { user } = useAuth();
  const [signKey, setSignKey] = useState(null);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const key = (user && user.zodiac_sign) || readMySign();
    setSignKey(key || null);
    if (!key) { setLoading(false); return; }
    getHoroscopeSign(key)
      .then((r) => setData(r))
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  }, [user]);

  if (loading) return null;

  if (!signKey) {
    return (
      <Link
        to="/il-mio-segno"
        data-testid="mysign-cta"
        className="group flex items-center justify-between gap-4 rounded-2xl border p-5 sm:p-6 transition-colors"
        style={{ backgroundColor: "rgba(139,92,246,0.08)", borderColor: "rgba(139,92,246,0.35)" }}
      >
        <div className="flex items-center gap-4">
          <span className="w-11 h-11 rounded-full flex items-center justify-center text-xl" style={{ backgroundColor: "rgba(139,92,246,0.15)" }}>✨</span>
          <div>
            <p className="font-mono text-[11px] font-bold uppercase tracking-wider" style={{ color: VIOLET }}>Il mio segno</p>
            <p className="font-serif text-lg font-semibold text-onSurface">Scopri il tuo oroscopo di oggi</p>
          </div>
        </div>
        <ChevronRight size={22} className="text-subtle group-hover:translate-x-1 transition-transform" style={{ color: VIOLET }} />
      </Link>
    );
  }

  const sign = data?.sign;
  const meta = ZODIAC_SIGNS.find((s) => s.key === signKey);
  if (!sign) return null;

  return (
    <Link
      to={`/articolo/${sign.article_id}/oroscopo-${signKey}`}
      data-testid="mysign-card"
      className="group block rounded-2xl border p-5 sm:p-6 transition-colors"
      style={{ backgroundColor: "rgba(139,92,246,0.08)", borderColor: "rgba(139,92,246,0.35)" }}
    >
      <div className="flex items-center gap-2 mb-2">
        <Sparkles size={15} style={{ color: VIOLET }} />
        <span className="font-mono text-[11px] font-bold uppercase tracking-wider" style={{ color: VIOLET }}>Oroscopo di oggi · {meta?.name || sign.name}</span>
      </div>
      <div className="flex items-start gap-4">
        <span className="text-3xl">{meta?.emoji || sign.emoji}</span>
        <div className="flex-1">
          <h3 className="font-serif text-lg font-semibold leading-snug text-onSurface group-hover:text-brand transition-colors">{sign.title}</h3>
          {sign.flash && <p className="text-sm text-subtle mt-1 line-clamp-2">{sign.flash}</p>}
          <div className="mt-2"><StarRating value={sign.stars} /></div>
        </div>
      </div>
    </Link>
  );
}
